var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 22,
    viewBox: "0 0 22 22",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.527 10.9991 4.6538-4.6437c.2038-.20382.3183-.48027.3183-.76853s-.1145-.56471-.3183-.76853c-.2038-.20383-.4802-.31834-.7684-.31834s-.5646.11451-.7684.31834l-4.643 4.65449-4.64304-4.65449c-.2038-.20383-.48021-.31834-.76842-.31834-.28822 0-.56463.11451-.76842.31834-.2038.20382-.3183.48027-.3183.76853s.1145.56471.3183.76853l4.65383 4.6437-4.65383 4.6436c-.10145.1007-.18196.2204-.23691.3523-.05494.1319-.08323.2734-.08323.4163s.02829.2844.08323.4163c.05495.1319.13546.2516.23691.3522.10061.1015.22031.182.3522.237.13188.0549.27334.0832.41622.0832.14287 0 .28434-.0283.41622-.0832.13189-.055.25159-.1355.3522-.237l4.64304-4.6545 4.643 4.6545c.1006.1015.2203.182.3522.237.1319.0549.2733.0832.4162.0832s.2843-.0283.4162-.0832c.1319-.055.2516-.1355.3522-.237.1015-.1006.182-.2203.2369-.3522.055-.1319.0833-.2734.0833-.4163s-.0283-.2844-.0833-.4163c-.0549-.1319-.1354-.2516-.2369-.3523z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ee3e09e8ca546c9ce7921cf223422ee2.svg";
export { ForwardRef as ReactComponent };